import { useEffect } from "react";
import { Box, Button, Typography, useTheme } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectPermissions } from "../../core/store/redux/slices/Permission-slice";
import { selectAuthData } from "../../core/store/redux/slices/Auth-slice";
import { resolveFeatureFromPath } from "../../core/permissions/route-feature-map";
import { Helper } from "../../utils/Helpers";

const { getGradientTextStyle } = new Helper();

export const AccessDenied = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { palette } = useTheme();
  const permissions = useSelector(selectPermissions);
  const authData = useSelector(selectAuthData);

  const attempted = location.state?.from || null;
  const feature = attempted ? resolveFeatureFromPath(attempted) : null;
  const hasAnyGrant = !!permissions && Object.keys(permissions).length > 0;

  useEffect(() => {
    console.warn("Access denied", {
      path: attempted || location.pathname,
      feature,
      user_key: authData?.user?.user_key,
      role_code: authData?.user?.role_code,
    });
  }, [attempted, feature, location.pathname, authData]);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 3,
      }}
    >
      <Box
        sx={{
          maxWidth: { xs: "100%", sm: "70%", md: "34%" },
          textAlign: "center",
        }}
      >
        <Box
          sx={{
            width: { xs: "18vw", sm: "9vw", md: "5vw" },
            height: { xs: "18vw", sm: "9vw", md: "5vw" },
            borderRadius: "50%",
            backgroundColor: "#FFF1E2",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 6% auto",
          }}
        >
          <LockOutlinedIcon
            sx={{
              color: palette.primary.main,
              fontSize: { xs: "9vw", sm: "4.5vw", md: "2.5vw" },
            }}
          />
        </Box>

        <Typography
          sx={{
            fontSize: { xs: "5vw", sm: "2.4vw", md: "1.4vw" },
            fontWeight: 700,
            mb: "2%",
            ...getGradientTextStyle(palette),
          }}
        >
          You do not have permission to perform this action.
        </Typography>

        <Typography
          sx={{
            fontSize: { xs: "3.6vw", sm: "1.6vw", md: "0.95vw" },
            color: "#6E6E6E",
            mb: "8%",
          }}
        >
          {hasAnyGrant
            ? "This page is not part of your role's access. If you need it, ask your administrator to grant it under Role Management."
            : "Your account does not have any permissions yet. Ask your administrator to assign the access you need."}
        </Typography>

        <Box
          sx={{
            display: "flex",
            gap: { xs: "1.8vw", sm: "1.8vw" },
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          <Button
            variant="outlined"
            onClick={() => navigate(-1)}
            sx={{
              fontWeight: 600,
              whiteSpace: "nowrap",
              fontSize: { xs: "4vw", sm: "1.9vw", md: "1.1vw" },
            }}
          >
            Go Back
          </Button>
          <Button
            variant="contained"
            onClick={() => navigate("/", { replace: true })}
            sx={{
              fontWeight: 600,
              whiteSpace: "nowrap",
              fontSize: { xs: "4vw", sm: "1.9vw", md: "1.1vw" },
            }}
          >
            Go to My Home Page
          </Button>
        </Box>
      </Box>
    </Box>
  );
};
